import React from 'react'

const Loading = ({ wrapperWidth, wrapperHeight, iconSize }) => (
  <div style={{ width: wrapperWidth || '100%', height: wrapperHeight || '100%', display: 'flex', justifyContent: 'center' }}>
    <img
      src="https://branding.arnsbomedia.com/voicearchive/icon/animated/as.svg"
      width={iconSize || 100}
    />
  </div>
)

export default Loading
